module.exports = __webpack_public_path__ + "img/Weapon_34.b288ace2.png";